import { memo } from "react";
import { Link } from "react-router-dom";

import SayagieLogo from "../../../components/SayagieLogo";

const AuthFooter = memo(function AuthFooter({ enterprise, children }) {
  return (
    <footer className="auth-foot">
      <SayagieLogo size="mark" className="auth-foot-logo" />

      <p className="auth-enterprise">{enterprise}</p>

      <p className="auth-fineprint">{children}</p>
    </footer>
  );
});

export const LegalLink = ({ to, children }) => (
  <Link className="auth-fineprint-link" to={to}>
    {children}
  </Link>
);

export default AuthFooter;
